import gql from "graphql-tag";

const GET_AVAILABLE_WATERMARKS = gql`
    query GetWatermarks {
        availableWatermarks {
            filename
        }
    }
`

const CREATE_USER_CLIP = gql`
  mutation CreateUserClip($userClipRequestInput: UserClipRequestInput!) {
    createUserClip(clipRequest: $userClipRequestInput) {
      success
      uri
      id
      width
      height
      durationInSeconds
      thumbnails {
        uri
      }
      warnings
      errors
      clipOutputType
    }
  }
`;

const OUTPUT_TYPES = gql`
  mutation OutputTypes(
    $clipId: String!
    $clipOutputTypeRequest: [ClipOutputType]!
  ) {
    outputTypes(
      clipId: $clipId
      clipOutputTypeRequest: $clipOutputTypeRequest
    ) {
      clipId
      outputTypes
      linksByType {
        videoType
        link
      }
      errors
    }
  }
`;

export { CREATE_USER_CLIP, OUTPUT_TYPES, GET_AVAILABLE_WATERMARKS };



// WEBPACK FOOTER //
// ./src/httpClients/graphql/clippy-mutations.js